package com.cs.ejobin.platform

import kotlinx.browser.window

actual fun openUrlDocument(url: String) {
    window.open(url, "_blank")
}